import { render, staticRenderFns } from "./BlockCard.vue?vue&type=template&id=c92a5c78&scoped=true"
import script from "./BlockCard.vue?vue&type=script&lang=js"
export * from "./BlockCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a5c78",
  null
  
)

export default component.exports